/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_Read_ErrorInputs */

const es_tools_gmail_read_error = /** @type {(inputs: Tools_Gmail_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al leer correo de Gmail`)
};

const en_tools_gmail_read_error = /** @type {(inputs: Tools_Gmail_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error reading Gmail message`)
};

/**
* | output |
* | --- |
* | "Error reading Gmail message" |
*
* @param {Tools_Gmail_Read_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_read_error = /** @type {((inputs?: Tools_Gmail_Read_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_Read_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_read_error(inputs)
	return en_tools_gmail_read_error(inputs)
});
export { tools_gmail_read_error as "tools.gmail.read_error" }